import React from "react";
import { Badge, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CurrencyValue from "../CurrencyValue";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

const HOneDetails = ({ plans }) => {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <Card bg="dark1">
      <Card.Header>
        <h6 className="text-light">X-ONE</h6>
      </Card.Header>
      <Card.Body>
        <DataTable
          value={plans}
          sortMode="multiple"
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          size={"small"}
          showGridlines
          stripedRows
          removableSort
        >
          <Column
            sortable
            field="contract_date"
            header={t("date")}
            body={(rowData) => {
              return rowData?.contract_date
                ? moment(rowData?.contract_date).format('DD-MM-YYYY') 
                : ""; 
            }} 
          />
          <Column sortable field="contract_code" header={t("contractNumber")} />
          <Column
            sortable
            field="duration"
            header={t("caseDuration")}
            body={(rowData) => `${rowData.duration} ${t("years")}`}
          />
          <Column
            sortable
            field="total_gr"
            header={t("gramsPurchased")}
            body={(rowData) => `${rowData.total_gr}gr`}
          />
          <Column
            sortable
            field="total_payment"
            header={t("totalPayment")}
            body={(rowData) => (
              <CurrencyValue
                amount={rowData.total_payment}
                currency={rowData.currency}
                rate={rowData.exchange_rate}
              />
            )}
          />
          <Column
            sortable
            field="total_payment_with_margin"
            header={t("totalGuarantee")}
            body={(rowData) => (
              <CurrencyValue
                amount={rowData.total_payment_with_margin}
                currency={rowData.currency}
                rate={rowData.exchange_rate}
              />
            )}
          />
          <Column
            sortable
            field="bankTransfer"
            header={t("totalBankTransfer")}
            body={(rowData) => (
              <CurrencyValue
                amount={rowData.bankTransfer}
                currency={rowData.currency}
                rate={rowData.exchange_rate}
              />
            )}
          />
          <Column
            sortable
            header={t("status")}
            body={(rowData) => (
              <Badge
                bg={`${rowData.status === "Active" ? "success" : "secondary"}`}
              >
                {rowData.status === "Active" ? t("active") : t("inactive")}
              </Badge>
            )}
          ></Column>
          <Column
            body={(rowData) => (
              <Link
                to={`/${lang}/plan/excelior-one/${rowData.contract_code}`}
                className="btn btn-outline-light btn-sm"
              >
                <i className="fa fa-eye" />
              </Link>
            )}
          />
        </DataTable>
      </Card.Body>
    </Card>
  );
};

export default HOneDetails;
